import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { FiShoppingCart } from "react-icons/fi";
import "./BookCard.css";

export default function BookCard({ book }) {
    const isBundle = book.productType === "bundle";
    const detailPath = isBundle ? `/bundle/${book.id}` : `/book/${book.id}`;
    const hasVariants = book.variants && book.variants.length > 0;
    // Show lowest variant price as "from" price
    const displayPrice = hasVariants
        ? Math.min(...book.variants.map(v => v.price || 0))
        : Number(book.price);
    const priceLabel = hasVariants ? `from $${displayPrice.toFixed(2)}` : `$${displayPrice.toFixed(2)}`;
    const languageFlag = book.language === "Spanish" ? "🇵🇷" : book.language === "English" ? "🇺🇸" : null;

    return (
        <div className="book-card">
            <Link to={detailPath} className="book-card-img-wrap">
                <img src={book.imageUrl} alt={book.title} loading="lazy" />
                {/* Format badge — bottom left */}
                {isBundle ? (
                    <span className="card-badge" style={{ background: "#7c3aed" }}>📦 Bundle</span>
                ) : hasVariants ? (
                    <span className="card-badge">{book.variants.length} Formats</span>
                ) : book.isDigital ? (
                    <span className="card-badge">Digital</span>
                ) : (
                    <span className="card-badge physical">{book.format || "Physical"}</span>
                )}
                {/* Language badge — top right */}
                {languageFlag && (
                    <span className="card-badge language" title={book.language}>
                        {languageFlag} {book.language === "Spanish" ? "ES" : "EN"}
                    </span>
                )}
                {book.isFeatured && <span className="card-badge featured">Featured</span>}
                {book.isPreorder && <span className="card-badge preorder" style={{ background: "#e65100", color: "#fff" }}>Pre-order</span>}
            </Link>
            <div className="book-card-body">
                <Link to={detailPath}>
                    <h3 className="book-card-title">{book.title}</h3>
                </Link>
                <p className="book-card-category">{book.category}</p>
            <div className="book-card-footer">
                    <span className="book-card-price">{priceLabel}</span>
                    {/* Navigate to detail page to choose variant */}
                    <Link
                        to={detailPath}
                        className="add-to-cart-btn"
                        aria-label={`View ${book.title} options`}
                        style={{ textDecoration: "none", display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        <FiShoppingCart size={16} />
                    </Link>
                </div>
            </div>
        </div>
    );
}